import { useState } from "react";

const INITIAL_STATE = {
  activeTab: 1,
};

export default function useActions() {
  const [state, setState] = useState(INITIAL_STATE);

  const handleActiveTab = (tab) => {
    setState((prev) => ({ ...prev, activeTab: tab }));
  };

  return [{ state }, { handleActiveTab }];
}
